import { useLocation } from 'react-router-dom';

// El hook useQueryParams devuelve todos los parámetros de la URL como un objeto.
const useQueryParams = (): Record<string, string | null> => {
    const location = useLocation();

    // Creamos una instancia de URLSearchParams para analizar los parámetros de la URL
    const queryParams = new URLSearchParams(location.search);

    // Convertimos los parámetros en un objeto
    const paramsObject: Record<string, string | null> = {};

    queryParams.forEach((value, key) => {
        paramsObject[key] = value;
    });

    return paramsObject;
};

export default useQueryParams;
